import { Fragment } from 'react';

export const Viewport = {
  Aware: Fragment,
  Tracker: Fragment,
}
